import {
  BreakoutType,
  TimelinePaneTypeType,
  TimelineSegmentOpType,
  TimelineSegmentType,
} from "shared/types";

export const getBreakoutForTimelineSegment = (
  segment: TimelineSegmentType,
  breakouts: BreakoutType[],
) => {
  if (
    segment.op === TimelineSegmentOpType.Breakout ||
    segment.op === TimelineSegmentOpType.FeatureAllGroupsPeopleAndNotes
  ) {
    return (
      breakouts.find(
        (breakout) => breakout.title.toLowerCase() === segment.breakout.toLowerCase(),
      ) || null
    );
  }
  return null;
};

export const hasPollsInTimelineSegment = (segment: TimelineSegmentType) => {
  return segment.panes?.some((pane) => pane.type === TimelinePaneTypeType.Poll);
};

export const hasResourcesInTimelineSegment = (segment: TimelineSegmentType) => {
  return segment.panes?.some((pane) => pane.type === TimelinePaneTypeType.Resource);
};
